var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.title + _vm.$t("notifySetting.title"),
      visible: _vm.settingVisible,
      width: _vm.width,
      dialogStyle: {
        top: "50px"
      },
      footer: null
    },
    on: {
      cancel: function cancel() {
        return _vm.$emit("SettingCancel");
      }
    }
  }, [_c("StandardTableVue", {
    attrs: {
      columns: _vm.columnsNotify,
      dataSource: _vm.data,
      pagination: false,
      rowKey: "id"
    },
    scopedSlots: _vm._u([{
      key: "showOrder",
      fn: function fn(_ref) {
        var text = _ref.text,
          index = _ref.index;
        return _c("span", {}, [_vm._v(" " + _vm._s(index + 1) + " ")]);
      }
    }, {
      key: "switchStatus",
      fn: function fn(_ref2) {
        var text = _ref2.text;
        return _c("span", {}, [_c("a-tag", {
          attrs: {
            color: text === 0 ? "red" : "blue"
          }
        }, [_vm._v(" " + _vm._s(text == 0 ? _vm.$t("disabled") : _vm.$t("Enable")) + " ")])], 1);
      }
    }, {
      key: "action",
      fn: function fn(_ref3) {
        var record = _ref3.record;
        return _c("span", {}, [_c("a-popconfirm", {
          attrs: {
            title: record.switchStatus == 0 ? _vm.$t("EnableMessage") : _vm.$t("disabledMessage"),
            "ok-text": _vm.$t("yes"),
            "cancel-text": _vm.$t("no")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirm(record);
            },
            cancel: _vm.cancel
          }
        }, [_c("a", [_vm._v(_vm._s(record.switchStatus == 0 ? _vm.$t("Enable") : _vm.$t("disabled")))])]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a", {
          on: {
            click: function click() {
              return _vm.$emit("notifyPreview", record);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("preView")) + " ")])], 1);
      }
    }])
  }), _c("a-modal", {
    attrs: {
      footer: null,
      visible: _vm.showHtml,
      width: _vm.notiType == "special" ? "350px" : "520px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.showHtml = $event;
      },
      cancel: function cancel() {
        return _vm.$emit("update:showHtml", false);
      }
    }
  }, [_c("img", {
    staticStyle: {
      width: "100%",
      height: "100%"
    },
    attrs: {
      src: _vm.html,
      alt: ""
    }
  })])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };